import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";
import { Promotion, Quest } from "@quest_editor/mocks";

const PromotionInfoSection = ({
  quest,
  promotion,
  getTypeLabel,
  buildOptionsDisplay,
}: {
  quest: Quest;
  promotion: Promotion;
  getTypeLabel: (type: string) => string;
  buildOptionsDisplay: (promotion: Promotion | null | undefined) => string[];
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("start_request.section.promotion_info")}
      rows={[
        {
          label: t("start_request.field.promotion_info.quest_id"),
          children: (
            <Typography color="text.secondary">{quest.id}</Typography>
          ),
        },
        {
          label: t("start_request.field.promotion_info.promotion_name"),
          children: (
            <Typography color="text.secondary">{promotion.name}</Typography>
          ),
        },
        {
          label: t("start_request.field.promotion_info.type"),
          children: (
            <Typography color="text.secondary">
              {getTypeLabel(promotion.type)}
            </Typography>
          ),
        },
        {
          label: t("start_request.field.promotion_info.description"),
          children: (
            <Typography color="text.secondary" sx={{ whiteSpace: "pre-wrap" }}>
              {promotion.description}
            </Typography>
          ),
        },
        {
          label: t("start_request.field.promotion_info.options"),
          children: (
            <Stack direction="column" spacing={1}>
              {buildOptionsDisplay(promotion).map((option, index) => (
                <Typography key={index} variant="body2" color="text.secondary">
                  {option}
                </Typography>
              ))}
            </Stack>
          ),
        },
      ]}
    />
  );
};

export default PromotionInfoSection;
